export default __webpack_public_path__ + "static/media/IMG_0048.da1c5afb.jpeg";